export class SANDRETaxionModel {
    Code: number;
    CodeIBMR?: string;
    Genre: string;
    Famille: string;
    Ordre: string;
    Gfi: number;
    Position: number;
    Instruction: string;
    IsPhyto: boolean = false;

    static mapFromJSON(json: any): SANDRETaxionModel {
        const t = new SANDRETaxionModel();

        t.Code = json.code;
        t.CodeIBMR = json.codeIBMR;
        t.Genre = json.genre;
        t.Famille = json.famille;
        t.Ordre = json.ordre;
        t.Gfi = json.gfi;
        t.Position = json.position;
        t.Instruction = json.instruction;
        t.IsPhyto = json.isPhyto;

        return t;
    }
}
